import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnDestroy {
  windowWidth!: string;
  showSplash = true;
  currentTheme: string = '';
  isThemeChanging: boolean = false;
  private themeSubscription: Subscription;
  private themeChangeTimeout: any;

  constructor(
    private themeService: ThemeService,
    private cdr: ChangeDetectorRef
  ) {

    this.currentTheme = this.themeService.getCurrentThemeName();

    this.themeSubscription = this.themeService.themeChanged$.subscribe(() => {
      this.isThemeChanging = true;
      this.cdr.detectChanges();

      if (this.themeChangeTimeout) {
        clearTimeout(this.themeChangeTimeout);
      }

      this.themeChangeTimeout = setTimeout(() => {
        this.currentTheme = this.themeService.getCurrentThemeName();
        this.isThemeChanging = false;
        this.cdr.detectChanges();
      }, 100);
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.windowWidth = '-' + window.innerWidth + 'px';

      setTimeout(() => {
        this.showSplash = !this.showSplash;
      }, 500);
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    if (this.themeChangeTimeout) {
      clearTimeout(this.themeChangeTimeout);
    }
  }
}
